import { render } from "./Settings.vue?vue&type=template&id=12a4c43b"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
script.render = render

export default script